import styles from "./PremiumPillIcon.module.css";

export default function PremiumPillIcon() {
  return (
    <div className={styles.main}>
      <p>PLUS</p>
    </div>
  );
}
